module.exports = __webpack_public_path__ + "static/media/rainbow-beetroot.7f35e7ec.jpg";